import { render, staticRenderFns } from "./keyword-rank-pie.vue?vue&type=template&id=3923f281&scoped=true&"
import script from "./keyword-rank-pie.vue?vue&type=script&lang=js&"
export * from "./keyword-rank-pie.vue?vue&type=script&lang=js&"
import style0 from "./keyword-rank-pie.vue?vue&type=style&index=0&id=3923f281&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3923f281",
  null
  
)

export default component.exports